<div class="email-thread-container w-p-100">
  <div class="thread-email" *ngFor="let email of emailThread.emails">
    <app-single-email-container [email]="email" [labels]="emailThread.labels"></app-single-email-container>
  </div>
</div>
